<template>
    <div style="display: flex; flex-direction: column; background-color: #fff;">
        <div style="margin-top: 31px; position: relative; display: flex; margin-bottom: 16px; align-items: center; justify-content: space-between; padding: 0 12px;">
            <div style="display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                <img :src="require('@/assets/img/ico-move_black.png')" style="width: 10px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="padding: 8px 16px; position: absolute; left: 50%; transform: translateX(-50%); display: inline-block; font-size: 14px; line-height: 20px; font-weight: 700; border-radius: 20px; background: #210F03E5; text-align: center; color: #fff;">
                {{ noticeDetail.view_cnt }}명이 조회
            </div>
        </div>
        <div style="height: 100%; padding: 0 12px; overflow-y: scroll; padding-bottom: 120px; position: relative;">
            <div style="margin-top: 20px; display: flex; flex-direction: column; align-items: center;">
                <div style="width: 60px; display: flex; justify-content: center; align-items: center; height: 60px; border: 2px solid #d9d9d9; border-radius: 50%; background-color: #f5f5f5;">
                    <img v-if="noticeDetail.notice_type === NOTICE_TYPE.NOTICE" style="width: 33px;" :src="require('@/assets/img/logo_notice.png')" alt="">
                    <img v-else style="width: 28px;" :src="require('@/assets/img/logo_event.png')" alt="">
                </div>
                <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-top: 8px; color: var(--color-main);">{{ noticeDetail.notice_type === NOTICE_TYPE.NOTICE ? '공지사항' : '이벤트' }}</div>
                <div style="display: flex; align-items: center; color: #606060; gap: 4px; font-weight: 400; font-size: 12px; line-height: 16px;">
                    {{ $Util.getMMDDDayHHmm(noticeDetail.notice_date) }}
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div style="background-color: #f5f5f5; border-radius: 12px; padding: 12px;">
                    <div style="font-weight: 700; line-height: 24px;">{{ noticeDetail.title }}</div>
                    <div style="margin-top: 8px; font-size: 14px; font-weight: 500; line-height: 24px; white-space: pre-wrap;">{{ noticeDetail.contents }}</div>
                    <template v-if="noticeDetail.image_list">
                        <div v-for="each, i in noticeDetail.image_list" :key="i" style="margin-top: 8px; border-radius: 12px; overflow: hidden; border: 1px solid #ebebeb;">
                            <img style="width: 100%; object-fit: cover;" :src="$resourcePath + each.file_path" alt="">
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <template>
            <div v-if="noticeDetail.btn_name && noticeDetail.btn_name !== '표시안함'" @click="doAction" style="position: fixed; font-size: 14px; font-weight: 700; background-color: var(--color-main); width: 171px; height: 60px; bottom: 40px; left: 50%; transform: translateX(-50%); border-radius: 50px; line-height: 60px; text-align: center;">
                {{ noticeDetail.btn_name }}
            </div>
        </template>
        <!-- <template v-else>
            <div style="position: fixed; font-size: 14px; font-weight: 700; background-color: #D9D9D9; color: #808080; width: 171px; height: 60px; bottom: 40px; left: 50%; transform: translateX(-50%); border-radius: 50px; line-height: 60px; text-align: center;">
                이벤트 참여 완료
            </div>
        </template> -->
    </div>
</template>

<script>
import { NOTICE_TYPE } from '@/Constants'

export default {
    name: 'NoticeDetail',
    components: {},
    props: {
        notice_idx: {
            type: [String, Number],
            default: -1
        },
        isClickOutside: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            noticeDetail: {},
            isParticipated: false,
            NOTICE_TYPE: NOTICE_TYPE
        };
    },
    created() {
        this.getNoticeDetail()
        this.clickInside = this.$Once(this.clickInside)
    },
    computed: {

    },
    methods: {
        async clickInside() {
            const formData = new FormData()
            formData.append('notice_idx', this.notice_idx)

            const res = await this.$Axios.post('/api/notice/click/inside', formData)

            if (res.data.code === 0) {
                console.log('성공')
            }
        },
        doAction(){
            if(this.noticeDetail.notice_type === NOTICE_TYPE.EVENT) {
                this.$Util.sendEventClick('마이_이벤트_상세_화면이동버튼');
            }else if(this.noticeDetail.notice_type === NOTICE_TYPE.NOTICE){
                this.$Util.sendEventClick('마이_공지사항_상세_화면이동버튼');
            }
            if(this.noticeDetail.idx == '27'){
                this.$GlobalStore.closeModalAll();
            }
            this.clickInside()
            window.pushCustomManager.goScreen(null, null, this.noticeDetail.action,  this.noticeDetail.param1);
        },
        async getNoticeDetail() {
            const parameters = {}
            parameters.notice_idx = this.notice_idx
            parameters.is_visit = true
            parameters.is_click_outside = this.isClickOutside

            const res = await this.$Axios.get('/api/notice/detail', { params: parameters })

            const noticeDetail = res.data.notice_detail
            const isParticipated = res.data.is_participated
            this.noticeDetail = noticeDetail
            this.isParticipated = isParticipated
        }
    }
}
</script>

<style scoped></style>